import { render } from "./BioIntelligentPart3.vue?vue&type=template&id=2b8e9da4&scoped=true"
import script from "./BioIntelligentPart3.vue?vue&type=script&lang=js"
export * from "./BioIntelligentPart3.vue?vue&type=script&lang=js"

import "./BioIntelligentPart3.vue?vue&type=style&index=0&id=2b8e9da4&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b8e9da4"]])

export default __exports__